import { useState, useCallback, useEffect } from 'react';
import { getRepairFactoryListApi } from '@/api/bodyAndPaint';
import { RepairFactoryListResponse } from '@/types/api/bodyAndPaint';

interface GetRepairFactoryListHookProps {
  m_affiliate_id: number;
}
export const useGetRepairFactoryList = ({
  m_affiliate_id,
}: GetRepairFactoryListHookProps) => {
  const [repairFactoryList, setRepairFactoryList] =
    useState<RepairFactoryListResponse>({} as RepairFactoryListResponse);

  const fetchDate = useCallback(async () => {
    try {
      const fetch = await getRepairFactoryListApi({ m_affiliate_id });
      if (fetch) {
        setRepairFactoryList({ plants: fetch?.data.plants });
      } else {
        setRepairFactoryList({} as RepairFactoryListResponse);
        throw { 'invalid parameter': m_affiliate_id };
      }
    } catch (error) {
      console.error(error);
    }
  }, [m_affiliate_id]);
  useEffect(() => {
    fetchDate();
  }, [fetchDate]);

  return { repairFactoryList };
};
